import React from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import PriceInfo from '../PriceInfo';
import useApiClient from '../../../hooks/api/useApiClient';
import useFeedbackLabel from '../../../hooks/ui/useFeedbackLabel';
import { useSaveServiceContractMutation } from '../../../store/api-slices';

/**
 * Step 1 — package/plan selection. Persists the selection (setup package,
 * billing mode, store quantity) and advances once saved.
 */
export default function YousignSetupFeeStep({ data, update, setContract, setupPackages, discount, onSelected }) {
  const { t } = useTranslation(undefined, { keyPrefix: 'Components:Contract:YousignContractFlow' });

  const { ServiceContractsManager } = useApiClient();
  const { setErrorFeedback, renderFeedbackLabel } = useFeedbackLabel();
  const [saveContract, { isLoading: updating }] = useSaveServiceContractMutation();

  const onSetupPackageSelection = async (setupPackage) => {
    update('setup_package_id', setupPackage.id);
    const { data: responseData, error } = await saveContract({
      apiManager: ServiceContractsManager,
      data: {
        ...data,
        setup_package_id: setupPackage.id,
      },
    });

    if (error) {
      setErrorFeedback(error);

      return toast.error(t('toasts.failed_to_save_changes'));
    }

    setContract(responseData);

    return onSelected();
  };

  return (
    <>
      {renderFeedbackLabel}
      <PriceInfo
        data={data}
        loading={updating}
        setupPackages={setupPackages}
        discount={discount}
        onChange={update}
        onSetupPackageSelection={onSetupPackageSelection}
      />
    </>
  );
}
